import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryforceurbaniaonrentinpune() {



  const cardData = {
"keyword": "Luxury Force Urbania on Rent in Pune",

"headingDescription":
  "Shivai Travels offers Luxury Force Urbania on rent in Pune for premium group travel experiences including family tours, corporate outings, wedding transportation, airport transfers, pilgrimage trips, and outstation journeys across Maharashtra and India. Our luxury Force Urbania is designed for maximum comfort with spacious pushback seats, premium interior finishing, powerful air conditioning, ambient lighting, smooth suspension for long-distance travel, USB charging points, entertainment system, and ample luggage space. Ideal for 15–17 passengers, this luxury vehicle ensures a first-class travel experience for groups who want comfort, safety, and style in one ride. With experienced professional drivers, well-maintained vehicles, doorstep pickup and drop, flexible rental packages, and 24/7 customer support, Shivai Travels guarantees a smooth, safe, and luxurious group travel experience from Pune.",

"topPlaces": [
 
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a major metro city offering luxury tourism experiences including Marine Drive, Gateway of India, high-end shopping, and corporate travel opportunities."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a premium coastal getaway near Mumbai known for private beaches, luxury villas, and resorts, perfect for weekend luxury group trips."
  },
   {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are premium hill stations near Pune known for scenic valleys, waterfalls, forts, and monsoon beauty, making them ideal for luxury Urbania road trips."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description":
      "Mahabaleshwar and Panchgani are famous luxury hill destinations known for strawberry farms, viewpoints, cool climate, and peaceful resorts for group travel."
  },
  {
    "title": "Goa",
    "description":
      "Goa is the top luxury outstation destination from Pune, known for beaches, nightlife, casinos, water sports, and high-end resorts ideal for Urbania group travel."
  },
  {
    "title": "Nashik & Sula Vineyards",
    "description":
      "Nashik is famous for vineyards, wine tourism, and scenic landscapes, making it a premium leisure destination for luxury group outings from Pune."
  },
  {
    "title": "Aurangabad (Ajanta & Ellora Caves)",
    "description":
      "Aurangabad offers UNESCO World Heritage Sites like Ajanta and Ellora Caves, ideal for luxury cultural and heritage tours from Pune."
  },
  {
    "title": "Konkan Coast (Ganpatipule, Ratnagiri)",
    "description":
      "The Konkan coast is known for pristine beaches, scenic drives, and luxury seaside resorts, perfect for premium Urbania road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination offering comfortable luxury travel for devotees visiting Sai Baba Temple from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city known for luxury architecture, lakeside views, and peaceful environment, ideal for short luxury group getaways."
  }
],



services: [
  {
    name: "Luxury Force Urbania Pune",
    description: "Luxury Force Urbania Pune service provides premium and spacious transportation for airport transfers, family trips, corporate travel, sightseeing tours, weddings, and outstation journeys. Luxury Urbania vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, ambient lighting, and luggage space suitable for executive and family travel requirements. Flexible booking options allow convenient luxury Force Urbania reservations in Pune."
  },
  {
    name: "Premium Urbania Rental Pune",
    description: "Premium Urbania rental Pune service offers dependable transportation solutions for travelers seeking luxury group travel within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient premium Urbania rental reservations."
  },
  {
    name: "Luxury Urbania Cab Pune",
    description: "Luxury Urbania cab Pune service provides affordable and comfortable executive travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury Urbania cab reservations."
  },
  {
    name: "Force Urbania Hire Pune",
    description: "Force Urbania hire Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Force Urbania hire reservations."
  },
  {
    name: "Urbania Luxury Travel Pune",
    description: "Urbania luxury travel Pune service offers economical and comfortable luxury transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, outstation journeys, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury travel Urbania reservations."
  },
  {
    name: "Cheap Luxury Urbania Pune",
    description: "Cheap luxury Urbania Pune service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient affordable luxury Urbania reservations."
  },
  {
    name: "Urbania Booking Service Pune",
    description: "Urbania booking service Pune offers spacious transportation for family tours, corporate outings, weddings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and executive travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania booking service reservations."
  },
  {
    name: "AC Luxury Urbania Pune",
    description: "AC luxury Urbania Pune service provides reliable transportation for local and outstation travel with premium air-conditioned interiors and spacious seating arrangements. Vehicles offer luggage space and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC luxury Urbania reservations."
  },
  {
    name: "Airport Luxury Urbania Pune",
    description: "Airport luxury Urbania Pune service provides dependable transportation for airport pickup and drop services from Pune Airport and nearby locations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient airport luxury Urbania reservations."
  },
  {
    name: "Outstation Luxury Urbania Pune",
    description: "Outstation luxury Urbania Pune service offers spacious and comfortable transportation for long-distance travel from Pune to nearby cities and tourist destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation luxury Urbania reservations."
  },
  {
    name: "Urbania One Way Luxury Pune",
    description: "Urbania one way luxury Pune service offers premium transportation for one-side journeys from Pune to outstation destinations with luxury seating and executive interiors. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and business transportation. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient one-way luxury Urbania reservations."
  },
  {
    name: "Urbania Round Trip Luxury Pune",
    description: "Urbania round trip luxury Pune service offers reliable group transportation for sightseeing tours, family vacations, airport transfers, and business travel with return options. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip luxury Urbania reservations."
  },
  {
    name: "Best Luxury Urbania Pune",
    description: "Best luxury Urbania Pune service provides complete executive transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient best luxury Urbania reservations."
  },
  {
    name: "Luxury Urbania with Driver Pune",
    description: "Luxury Urbania with driver Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for weddings, family trips, airport transfers, sightseeing tours, and outstation travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury Urbania with driver reservations."
  },
  {
    name: "VIP Urbania Rental Pune",
    description: "VIP Urbania rental Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination weddings, sightseeing trips, airport travel, and executive tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient VIP Urbania rental reservations."
  }
],

tableData: [
  ["Luxury Force Urbania Pune", "Premium Urbania Rental Pune"],
  ["Luxury Urbania Cab Pune", "Force Urbania Hire Pune"],
  ["Urbania Luxury Travel Pune", "Cheap Luxury Urbania Pune"],
  ["Urbania Booking Service Pune", "AC Luxury Urbania Pune"],
  ["Airport Luxury Urbania Pune", "Outstation Luxury Urbania Pune"],
  ["Urbania One Way Luxury Pune", "Urbania Round Trip Luxury Pune"],
  ["Best Luxury Urbania Pune", "Luxury Urbania with Driver Pune"],
  ["VIP Urbania Rental Pune", "Luxury Force Urbania Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Luxury Force Urbania on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Luxury Force Urbania rental service in Pune with professional drivers, premium seating, and punctual pickup for smooth and comfortable luxury travel experiences."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Luxury Force Urbania on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Luxury Urbania Availability",
        WhyChoosedescription: "Our Luxury Force Urbania rental service in Pune operates 24 hours a day for corporate travel, weddings, airport transfers, family tours, VIP travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Premium & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Luxury Force Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained with luxury interiors for premium group travel comfort."
      },
      {
        WhyChooseheading: "One Way & Round Trip Luxury Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Luxury Urbania booking, round-trip travel, airport transfers, sightseeing tours, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Perfect Vehicle for Premium Group Travel",
        WhyChoosedescription: "Our Luxury Force Urbania vehicles are ideal for family vacations, corporate teams, wedding groups, VIP guests, tourists, and pilgrimage travel with spacious seating, luggage capacity, and modern luxury interiors."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Luxury Tours",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, Konkan roads, hill stations, and interstate destinations, ensuring safe driving and smooth luxury travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Luxury Force Urbania rental service in Pune?", answer: "Luxury Force Urbania rental service in Pune provides premium group transportation for corporate travel, weddings, airport transfers, family tours, and outstation journeys." },
    { question: "Is Luxury Force Urbania on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Luxury Force Urbania rental service in Pune." },
    { question: "Which seating options are available in Luxury Force Urbania?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Luxury Force Urbania vehicles." },
    { question: "Can I book Luxury Force Urbania for outstation travel?", answer: "Yes, customers can book Luxury Force Urbania vehicles for local sightseeing, airport transfers, corporate travel, and outstation tours." },
    { question: "Do you provide one-way and round-trip Luxury Urbania service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Luxury Force Urbania booking services." },
    { question: "Are all Luxury Force Urbania vehicles air-conditioned?", answer: "Yes, all Luxury Force Urbania vehicles are fully air-conditioned and maintained for comfortable premium travel." },
    { question: "Can I book Luxury Force Urbania on rent in Pune online?", answer: "Yes, customers can easily book Luxury Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Luxury Urbania vehicles for weddings and corporate events?", answer: "Yes, Shivai Travels provides Luxury Force Urbania vehicles for weddings, corporate outings, VIP travel, and family group transportation." },
    { question: "Are Luxury Force Urbania rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Luxury Force Urbania rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Luxury Force Urbania on rent in Pune with Shivai Travels. Premium vehicle, smooth journey, and excellent driver support for our corporate trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Luxury Force Urbania rental service in Pune. Affordable pricing, clean luxury vehicle, and wonderful premium group travel experience.",
      rating: 5
    }
  ];





  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/luxury-urbania-pune.jpg",
  "description": "Book Luxury Force Urbania on rent in Pune with Shivai Travels for premium, comfortable, and VIP group travel. Ideal for airport transfers, corporate trips, weddings, family outings, and outstation journeys with AC comfort and professional driver service available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹30/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/luxury-force-urbania-pune"
  }
};






  return (
    <div>



<Helmet>
  <title>Luxury Force Urbania on Rent in Pune | VIP Premium Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Luxury Force Urbania in Pune with Shivai Travels. VIP premium Urbania cab for airport transfers, corporate travel, weddings, family trips, and outstation journeys with AC comfort and driver service."
  />

  <meta
    name="keywords"
    content="luxury force urbania pune, premium urbania rental pune, luxury urbania cab pune, force urbania hire pune, urbania luxury travel pune, cheap luxury urbania pune, urbania booking service pune, ac luxury urbania pune, airport luxury urbania pune, outstation luxury urbania pune, urbania one way luxury pune, urbania round trip luxury pune, best luxury urbania pune, luxury urbania with driver pune, vip urbania rental pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryforceurbaniaonrentinpune;